import React, { cloneElement, ReactNode } from "react";
import { useImmer } from "use-immer";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import { Grid, Popover } from "@mui/material";

interface AreYouSureProps {
  keyId: string;
  buttonText: string;
  enabled: boolean;
  isLoading: boolean;
  message?: ReactNode;
  onYesClick: () => void;
  children: ReactNode;
  yesMessage?: string;
}

export const AreYouSure = ({
  keyId,
  enabled,
  isLoading,
  buttonText,
  children,
  message,
  onYesClick,
  yesMessage,
}: AreYouSureProps): any => {
  const [anchorEl, setAnchorEl] = useImmer<HTMLButtonElement | null>(null);

  const open = Boolean(anchorEl);
  const id = open ? keyId : undefined;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(null);
  };

  const handleYesClick = () => {
    onYesClick();
    setAnchorEl(null);
  };

  if (!enabled) {
    return children || null;
  }

  return (
    <>
      {cloneElement(children as any, { onClick: handleClick })}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        slotProps={{
          paper: {
            sx: {
              minHeight: "25px",
              minWidth: "200px",
              padding: "10px",
              border: "1px solid #e0e0e0",
            },
          },
        }}
      >
        <Grid
          container
          alignItems={"center"}
          justifyContent={"space-between"}
          columnSpacing={2}
        >
          <Grid item>
            {message ? message : <IgTypography>Are you sure?</IgTypography>}
          </Grid>
          <Grid item>
            <IgButton onClick={handleYesClick}>{yesMessage || "Yes"}</IgButton>
          </Grid>
        </Grid>
      </Popover>
    </>
  );
};
